/**
 * Cascadia locale — en-US (English, parity) — board-game-client copy.
 *
 * UI is NOT shared between playground and client (CLAUDE.md). Cloned intentionally.
 * Key set must stay identical to ko-KR.ts; i18n.test.ts enforces this.
 */

export const enUS: Readonly<Record<string, string>> = {
  // --- Error codes (spec §11.3) ---
  ERR_PHASE_MISMATCH: "That action isn't allowed in the current phase.",
  ERR_NOT_ACTIVE_SEAT: "It's not your turn.",
  ERR_STALE_VERSION: "Board state out of sync. Refreshing.",
  ERR_TILE_OCCUPIED: "That space already has a tile.",
  ERR_TILE_NOT_ADJACENT: "Tiles must touch an existing tile.",
  ERR_WILDLIFE_UNSUPPORTED: "This tile doesn't accept that wildlife.",
  ERR_WILDLIFE_SLOT_FILLED: "Tile already has a wildlife token.",
  ERR_WILDLIFE_TILE_LANDMARKED: "Landmark tiles can't hold wildlife.",
  ERR_NATURE_INSUFFICIENT: "Not enough nature tokens.",
  ERR_MARKET_SLOT_EMPTY: "That market slot is empty.",
  ERR_DECOUPLE_NOT_UNLOCKED:
    "Spend a nature token to unlock decoupled drafting first.",
  ERR_OPTIONAL_WIPE_NOT_TRIGGERED:
    "Optional wipe needs 3 identical wildlife in the market.",
  ERR_OPTIONAL_WIPE_ALREADY_USED:
    "You've already used the optional wipe this turn.",
  ERR_LANDMARK_TRIGGER_MISSING:
    "No 5-tile corridor triggered a landmark unlock.",
  ERR_LANDMARK_HABITAT_TAKEN: "You already own a landmark for that habitat.",
  ERR_LANDMARK_CARD_UNAVAILABLE: "That landmark card isn't in the pool.",
  ERR_AUTO_WIPE_PENDING: "Market is auto-wiping. Please wait.",
  ERR_DECOUPLE_ALREADY_UNLOCKED:
    "Decoupled draft is already unlocked this turn.",
  ERR_INVALID_WIPE_SLOTS: "Wipe-slot selection is invalid.",
  ERR_LEGAL_PLACEMENT_EXISTS:
    "Wildlife must be placed when a legal spot exists.",
  ERR_UNKNOWN_ACTION: "Unknown action. Reloading.",
  ERR_NO_GAME_STATE: "No game in progress.",

  // --- Turn phases (spec §6.2) ---
  phase_marketCheck: "Market check",
  phase_placeTile: "Place tile",
  phase_placeWildlife: "Place wildlife",
  phase_unlockLandmark: "Landmark",
  phase_endTurn: "End turn",
  phase_scoring: "Scoring",

  // --- Module labels ---
  module_landmarks: "Landmarks",
  module_solo: "Solo",
  module_family: "Family variant",
  module_intermediate: "Intermediate variant",
  module_ksPromo: "KS Promo",

  // --- Habitat names (spec §1.1) ---
  habitat_forest: "Forest",
  habitat_mountain: "Mountain",
  habitat_prairie: "Prairie",
  habitat_river: "River",
  habitat_wetland: "Wetland",

  // --- Wildlife species (spec §1.2) ---
  wildlife_bear: "Bear",
  wildlife_elk: "Elk",
  wildlife_salmon: "Salmon",
  wildlife_hawk: "Hawk",
  wildlife_fox: "Fox",

  // --- Common game terms ---
  nature_token: "Nature token",
  score: "Score",
  turn: "Turn",
  pass: "Pass",
  end_turn: "End turn",

  // --- Button labels ---
  btn_start_game: "Start game",
  btn_confirm: "Confirm",
  btn_skip_wildlife: "Skip wildlife",
  btn_skip_landmark: "Skip landmark",
  btn_wipe_optional: "Optional wipe",
  btn_spend_nature_decouple: "Spend nature → decouple",
  btn_spend_nature_wipe: "Spend nature → selective wipe",
  btn_play_again: "Play again",
  btn_back_to_lobby: "Back to lobby",
  btn_close: "Close",
  btn_learn_more: "Learn more",
  btn_skip: "Skip",
};
